import { makeStyles } from '@material-ui/styles'
   
const useStyles = makeStyles((theme) => ({  
  container:{
    bottom:0,
    left:0,
    right:0,
    backgroundColor: "#69696966",   
    paddingTop: "15px",
    paddingBottom: "15px",
    marginTop: "10px", 
    width: "100%",   
    },
    footer:{
      // position: "static",
      // display: "block",

    },

  }))
export default useStyles;

  